const LOCALES = {
    APP_NAME: "DATA BUREAU SERVICE",
    LABEL: {
      DBS_USER: "DBS User",
      DBS_ADMIN: "DBS Admin",
      DBS_FILE_UPLOAD: "DBS File Upload",
      ACKNOWLEDGE: "Acknowledge",
      OK: "OK",
      NOTE: "Note",
      CONFIRM: "Confirm",
      CANCEL: "Cancel",
      CLOSE: "Close",
      ADD_MORE_FILES: "Add more files",
      ENTER_PASSWORD: "Enter password",
      SECTOR: "Sector",
      SUB_SECTOR: "Sub Sector",
      SUB_SUB_SECTOR: "Sub-Sub Sector",
      REVENUE_RANGE: "Revenue Range",
      FUNCTION: "Function",
      SSL_COMPETENCY: "SSL Competency",
      WELCOME: "Welcome",
      TARGET_SUPER_REGION: "Target Super Region",
      SUPER_REGION: "Super Region",
      TARGET_COUNTRY: "Target Country",
      COUNTRY: "Country",
      TARGET_SECTOR: "Target Sector",
      TARGET_SUB_SECTOR: "Target Sub Sector",
      TARGET_SUB_SUB_SECTOR: "Target Sub-Sub Sector",
      TARGET_REPORTED_REVENUE_RANGE: "Target Reported Revenue Range ",
      REPORTED_REVENUE_RANGE: "Reported Revenue Range ",
      TARGET_SSL: "Target SSL/Competency",
      SSL: "SSL/Competency",
      ADD_DATA_UPLOADERS_SELECTED_ENGAGEMENTS:
        "Add data uploaders to the selected engagements",
      LIST_OF_DATA_UPLOADERS: "List of data uploaders ",
      UPLOAD_DATA: "Upload Data",
      CHOOSE_FILES_TO_UPLOAD: "Choose files to upload",
      ADD_ENGAGEMENT: "Add Engagement",
      COMPLETE_THE_EMGAGEMENT_PROFILE:
        "Please complete the Engagement Profile below to process the Engagement data:",
      ENTER_DETAILS_TO_PROCEED: "Enter Details to Proceed",
      ENGAGEMENT_ID: "Engagement Id",
      PROJECT_NAME: "Project Name",
      CLIENT_NAME: "Client Name",
      AREA: "Area",
      REGION: "Region",
      CONNECTED_CAPITAL_SOLUTION: "Connected Capital Solution",
      EMAIL: "Email",
      NAME: "Name",
      ACCESS_TYPE: "Access Type",
      COMMENTS: "Comments",
    },
    LOGIN: {
      ROLE: {
        PARTNER: "Partner",
        USER: "User",
        ADMIN: "Admin",
      },
      USER_NOT_EXISTS: "User doesn't exsist",
      WARNING: "Another interaction is currently in progress. Please wait.",
      ERROR_CODE: "interaction_in_progress",
    },
    ACKNOWLEDGE_MODAL: {
      HEADER: "Privacy Note – EY-P Data Bureau Service",
      ACKNOWLEDGE_ONE:`<strong>1. Introduction</strong><br />
    This Privacy Notice is intended to describe the practices EY follows in relation to the EY-P Data Bureau Service data Upload Interface tool (“Tool”) with respect to the privacy of all individuals whose personal data is processed and stored in the Tool. This Privacy Notice should be read together with the ey.com Privacy Statement, and in case of any conflict with the ey.com Privacy Statement, the terms of this Privacy Notice will prevail. Please read this Privacy Notice carefully.`,
      ACKNOWLEDGE_TWO: `<strong>2. Who manages the Tool?</strong><br />
    “EY” refers to one or more of the member firms of Ernst & Young Global Limited (“EYG”), each of which is a separate legal entity and can act as a data controller or in a similar capacity. The entity that is acting as data controller by providing this Tool on which your personal data will be processed and stored is:<br />
    o For the personal data of EY personnel: The data controller is the EY entity which employs you.<br />
    You can find a list of local EY member firms and affiliates on the ey.com Privacy Statement.<br />
    The personal data in the Tool is shared by EYGM Limited with one or more member firms of EYG (see “Who can access your personal data” section 6 below).<br />
    The Tool is hosted externally in an EY Managed MS Azure Data Centre in the United States of America, Netherlands (server back-up in Ireland), and Australia.`,
    ACKNOWLEDGE_THREE: `<strong>3. How does the Tool process personal data?</strong><br />
    The Tool is a common access point to enable EY-P Partners and staff to upload permitted client engagement data to the EY-P Data Bureau Service regional storage facilities. The Tool will enable EY employees to provide permitted client engagement data to the Data Bureau Service that the Data Bureau Service will sanitize, in line with EY and EY-P data sanitization and data protection guidelines, and then use these data to generate anonymized benchmarks and insights for use by EY-P Partners and staff in selling and delivering engagements. <br />
    The Data Bureau Service Upload Interface tool is used to upload permitted engagement data files to the Data Bureau Service regional storage facilities outlined [below].<br />
    The Data Bureau Service will log user access history - specifically time, date and duration of access and the activities performed by the user when, specifically which files were uploaded by the user.<br />
    The Data Bureau Service data Upload Interface Log Data will be retained in accordance with the EY IT Logging Policy and comply with EY’s Information Security requirements regarding logs of user access (based on C2 ratings).<br />
    o Log data is anonymized - in compliance with regulations restricting collection of personal identifiable information<br />
    o Log data is a “snapshot in time” and is not modified in any way</p>
    
    <p>Your personal data processed in the Tool is used as follows: Personal data is processed to verify and log login credentials and activity.<br />
    EY relies on the following basis to legitimize the processing of your personal data in the Tool: legitimate interests.<br />
    Processing of your personal data is necessary for the purposes of the legitimate interests pursued by the data controller or by a third party, except where such interests are overridden by the interests or fundamental rights and freedoms of the data subject which require protection of personal data. The specific legitimate interest is the conducting of client engagements.<br />
    You have the right to object at any time, on grounds relating to your particular situation, to the processing of personal data concerning you based on the above legitimate interest(s).<br />
    In some jurisdictions, personal data of the data subjects is being processed pursuant to the relationship resulting from the employment contract with such data subjects and is necessary for the controller or data subject to carry out their obligations in the field of employment and therefore, for the execution of such contracts.`,
      ACKNOWLEDGE_FOUR: `<strong>4. What type of personal data is processed in the Tool?</strong><br />
    The Tool processes these personal data categories:<br />
    User Group - Username and password of individuals in the Authorized User Group.<br />
    This data is sourced from: EY Active Directory.`,
      ACKNOWLEDGE_FIVE: `<strong>5. Sensitive personal data</strong><br />
    Sensitive personal data reveals your racial or ethnic origin, political opinions, religious or philosophical beliefs, trade union membership, genetic data, biometric data, data concerning health or data concerning sex life or sexual orientation.<br />
    EY does not intentionally collect any sensitive personal data from you via the Tool. The Tool’s intention is not to process such information.`,
      ACKNOWLEDGE_SIX: `<strong>6. Who can access your personal data?</strong><br />
    Your personal data is accessed in the Tool by the following persons/teams:<br />
    Selected EY Project team (Admin and Analyst) and client team members have access to the data.<br />
    <table className="ack-table">
      <thead>
        <tr>
          <th className="th">USER GROUP</th>
          <th className="th">LOCATION</th>
          <th className="th">PURPOSE</th>
          <th className="th">ACCESS</th>
          <th className="th">AMOUNT</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td className="td">Group name</td>
          <td className="td">Identify country</td>
          <td className="td">The action that the group performs</td>
          <td className="td">Identify whether access is read, update, add</td>
          <td className="td">Provide the approx. number of users with access</td>
        </tr>
        <tr>
          <td className="td">EY-P DBS Admin</td>
          <td className="td">Global</td>
          <td className="td">Admin will be responsible for maintaining the system including monitoring the log of user interactions</td>
          <td className="td">Will require full access to the solution (data and IT backend).</td>
          <td className="td">±20</td>
        </tr>
        <tr>
          <td className="td">EY DBS Technical Team</td>
          <td className="td">Global</td>
          <td className="td">Business testing and feedback, monitoring user interactions.</td>
          <td className="td">Add, Read, Update</td>
          <td className="td">±20</td>
        </tr>
      </tbody>
    </table>`,
      ACKNOWLEDGE_SEVEN: `<strong>7. Data retention</strong><br />
    Our policy is to retain personal data only for as long as it is needed for the purposes described in the section “How does the Tool process personal data”. Retention periods vary in different jurisdictions and are set in accordance with local regulatory and professional retention requirements.<br />
    In order to meet our professional and legal requirements, to establish, exercise or defend our legal rights and for archiving and historical purposes, we need to retain information for significant periods of time.<br />
    Log Data will be retained in accordance with the EY IT Logging Policy.<br />
    After the end of the data retention period, your personal data will be deleted.`,
      ACKNOWLEDGE_EIGHT: `<strong>8. Security</strong><br />
    EY protects the confidentiality and security of information it obtains in the course of its business. Access to such information is limited, and policies and procedures are in place that are designed to safeguard the information from loss, misuse and improper disclosure. Additional information regarding our approach to data protection and information security is available in our ey-protecting-your-data-brochure-v2.pdf brochure.`,
      ACKNOWLEDGE_NINE: `<strong>9. Controlling your personal data</strong><br />
    EY will not transfer your personal data to third parties (other than any external parties referred to in section 6 above) unless we have your permission or are required by law to do so.`,
      ACKNOWLEDGE_TEN: `<strong>10. Your rights in relation to your personal data</strong><br />
    Depending on the applicable jurisdiction, you may have certain rights in relation to your personal data, including:<br />
    o To request details of the personal data EY processes about you and to access the personal data that EY processes about you<br />
    o To have your personal data corrected, for example, if it is incomplete or incorrect<br />
    o To restrict or object to the processing of personal data or request the erasure of your personal data<br />
    o To receive a copy of the personal data which you have provided to EY in a structured, commonly used and machine-readable format which you can re-use for your own purposes (known as “data portability”)<br />
    o Where you have provided consent to the processing of your personal data, the right to withdraw your consent.<br />
    o The right to complain to a data protection authority (see section “Complaints”)<br />
    If you have any questions about how EY processes your personal data or your rights related to your personal data, please send an e-mail to global.data.protection@ey.com`,
      ACKNOWLEDGE_ELEVEN: `<strong>11. Complaints</strong><br />
    If you are concerned about an alleged breach of privacy law or any other regulation, contact EY’s Global Privacy Leader, Office of the General Counsel, 1 More London Place, London, SE1 2af, United Kingdom or via email at global.data.protection@ey.com or via your usual EY representative. An EY Privacy Leader will investigate your complaint and provide information about how it will be handled and resolved.<br />
    If you are not satisfied with how EY resolved your complaint, you may have the right to complain to your country’s data protection authority. You may also have the right to refer the matter to a court of competent jurisdiction.<br />
    Certain EY member firms in countries outside the European Union (EU) and the UK have appointed representatives in the EU and the UK respectively to act on their behalf if, and when, they undertake data processing activities to which the EU General Data Protection Regulation (GDPR) and/or the UK General Data Protection Regulation (UK GDPR) applies. Further information and the contact details of these representatives are available below:<br />
    EU data protection representative | EY<br />
    UK Data protection representative (ey.com)`,
      ACKNOWLEDGE_TWELVE: `<strong>12. Contact us</strong><br />
    If you have additional questions or concerns, contact your usual EY representative or email global.data.protection@ey.com.`,
      ACKNOWLEDGE_LABEL: "I agree the privacy statement",
    },
    RESTRICTION: {
      FIRST_MESSAGE:
        "The role is currently restricted. Please contact the Data Bureau Service at",
      LINK: "DBS@parthenon.ey.com",
      LAST_MESSAGE: "for access.",
    },
    REASON: {
      BACKDROPCLICK: "backdropClick",
      ESCAPEKEYDOWN: "escapeKeyDown",
    },
    LOADING: {
      TITLE: "Loading",
    },
    HOME: {
      TITLE_PARTNER: "Welcome to The EYP DBS",
      TITLE_ADMIN: "The Data Bureau Service",
      PARTNER: {
        TITLE:
          "The EY-Parthenon Data Bureau Service harnesses EY-P's vast global client and engagement experience and data to create unique and powerful benchmarks and insights that enable you to differentiate EY-P in the market and sell, win and deliver more effectively.",
        SUB_TITLE:
          "The EY-P DBS Data Submission Portal enables you to send your engagement files to the EY-P DBS and provide key information about your engagement that the EY-P DBS will use to categorize the data collected and use this to search for and mine relevant data that we will use to create benchmarks and insights.",
      },
      ADMIN: {
        TITLE:
          "Welcome to the Data Bureau Service, EY-P's powerful benchmarks and insights service. The Data Bureau Service (DBS) harnesses EY-P's vast global client and engagement experience and data to create unique and powerful benchmarks and insights that enable you to differentiate EY-P in the market and sell, win and deliver more effectively.",
      },
    },
    ACTION: {
      EDIT: "Edit",
      DELETE: "Delete",
    },
    SESSION_CONFLICT: {
      TITLE: "Session Conflict",
      MESSAGE_TITLE: "Concurrent active session detected.",
      MESSAGE_DESCRIPTION: "You may not have logged out from a previous session.",
      CONFIRMATION:
        "Do you want to close the previous session and start new session?",
    },
    LOG_OUT: {
      MESSAGE: "You have been logged out from the Application.",
      LOGIN_LINK: "Click here",
      LOGIN_IN: " to login.",
    },
    ADD_ORGANIZATION_POPUP: {
      ERROR_MESSAGE: "Please select an option from the dropdown!",
    },
    BREADCRUMB: {
      HOME: "Home",
    },
    MESSAGES: {
      TIMEOUT: "The session is timed out, please start a new session to log in.",
      PWD_MESSAGE:
        "Your password is encrypted and stored temporarily and will be deleted after processing the files.",
      FILE_UPLOAD_SUCCESS_SUBMITTED:
        "The uploaded files have been successfully submitted",
      ZIP_FILE_UPLOAD_SCUCCESS: "Zip file uploaded successfully",
      FILE_UPLOAD_SUCCESS: "uploaded successfully",
      FILE_UPLOAD_RETRY: "upload failed. Please try again",
      FILE_UPLOAD_ERROR: "Something went wrong. Please try again",
      CONFIRM_DATA_UPLOAD: "Please confirm the data upload",
      FILE_UPLOAD_MESSAGE_ONE:
        "Important: Only one password can be used for each upload, if applicable; otherwise, please leave it blank.",
      FILE_UPLOAD_MESSAGE_TWO:
        "If your files have different passwords, upload them in batches. ",
      FILE_UPLOAD_MESSAGE_THREE:
        "Once you click 'Confirm,' your files will be uploaded to the regional DBS storage for processing by DBS. ",
      FILE_UPLOAD_MESSAGE_FOUR:
        "Please note that the password is not being checked on non-ZIP files until processing. ",
    },
  };
  
  export default LOCALES;
  